import { Fade, Grid, makeStyles } from "@material-ui/core";
import { useEffect, useRef, useState } from "react";
import useOutSideClick from "utilize/Hook/useOutSideClick";
import ArrowBackIosRoundedIcon from "@material-ui/icons/ArrowBackIosRounded";
import axios from "axios";
import Apis from "constants/Api";
import useStyles from "styles";

export default function SelectOption({ stateId, setStateID, setShow, items }) {
  const classes = useStyles();
  const [state, setState] = useState(false);
  const [fadeOpen, setFadeOpen] = useState(false);
  const selectRef = useRef(null);
  useOutSideClick(selectRef, () => {
    setFadeOpen(false);
  });
  const handleSelected = (item, id, bool) => {
    console.log(item, id);
    setState(item);
    setFadeOpen(false);
    setStateID(id);
    // setShow(bool);
  };
  return (
    <Grid container ref={selectRef} className={classes.SelectBoxRoot}>
      <Grid
        container
        alignItems="center"
        className={classes.selectBoxContainer}
        onClick={() => {
          setFadeOpen(!fadeOpen);
        }}
      >
        {state || items.find((el) => el.id === stateId)?.title}
        <ArrowBackIosRoundedIcon className={classes.arrowDownSelectBox} />
      </Grid>
      <Fade in={fadeOpen}>
        <Grid container className={classes.selectBoxFadeContainer}>
          {items &&
            items?.map((item, index) => {
              return (
                <Grid
                  key={index}
                  container
                  className={classes.selectBoxFadeItem}
                  onClick={() =>
                    handleSelected(
                      item.title,
                      item.id
                
                    )
                  }
                >
                  {item.title}
                </Grid>
              );
            })}
        </Grid>
      </Fade>
    </Grid>
  );
}
